module.exports = __webpack_public_path__ + "static/media/load.3e51c21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/load.png
// module id = 2984
// module chunks = 0